import algoliasearch from "algoliasearch"
import globals from "@/utils/globals"
import getLocale from "@/utils/locale"
import { isItemBlocked } from "@/services/blocklist-service"

const isSearchQueryTooTrivial = (query) => {
  const trimmed = query.trim().toLowerCase()
  return trimmed.length <= 2 || trimmed === "the"
}

let cachedAlgoliaIndexObject
const algoliaIndexAccessor = () => {
  if (!cachedAlgoliaIndexObject) {
    const client = algoliasearch(globals.algolia.appId, globals.algolia.apiKey)
    cachedAlgoliaIndexObject = client.initIndex(globals.algolia.indexName)
  }
  return cachedAlgoliaIndexObject
}

const createSearchQueryOptions = (userLanguages) => {
  return {
    attributesToRetrieve: ["title", "author", "slug", "language", "bundle"],
    hitsPerPage: 10,
    attributesToHighlight: ["title", "author"],
    filters: [
      `publishedAt < ${Math.floor(Date.now() / 1000)}`,
      `(${userLanguages.map((a) => `language:${a}`).join(" OR ")})`
    ].join(" AND ")
  }
}

const filterTransformAndDeduplicateResults = (searchResults, { hasContentAccess, blocklist }) => {
  const locale = getLocale()
  const bookBaseUrl = hasContentAccess ? `/${locale}/app/books` : `/${locale}/books`

  const books = {}
  ;(searchResults.hits || [])
    .filter((item) => !isItemBlocked(blocklist, "book", item.objectID))
    .map((item) => ({
      externalId: item.objectID,
      title: item.title,
      author: item.author,
      url: `${bookBaseUrl}/${item.slug}`
    }))
    // Deduplication by using a "hash table" object
    .forEach((item) => (books[item.url] = item))

  return Object.values(books)
}

export default async (query, { userLanguages, hasContentAccess, blocklist }) => {
  if (!globals.algolia) {
    return Promise.reject("Search not configured.")
  }

  if (isSearchQueryTooTrivial(query)) {
    return Promise.resolve()
  }

  const searchResults = await algoliaIndexAccessor().search(query, createSearchQueryOptions(userLanguages))

  return filterTransformAndDeduplicateResults(searchResults, { hasContentAccess, blocklist })
}
